export default __webpack_public_path__ + "static/media/aMaMeF2025-LOBvAMM.57150ee2.pdf";